import StatusBadge from 'components/badges/StatusBadge';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const CriticalStatusBadge: FunctionComponent<Props> = ({
    className = '',
    testId = TEST_ID,
    text
}) => {
    const { CRITICAL } = useTranslation();

    return (
        <StatusBadge
            className={`${className} ${styles.criticalStatusBadge}`}
            testId={testId}
            text={text ?? CRITICAL}
        />
    );
};

export default CriticalStatusBadge;
